import React from 'react';
import { Modal } from 'antd';
import { UpsellContent } from './FeatureGate';
import { useUpgradeModal, openUpgradeModal } from './upgradeModalStore';

// App-wide upgrade/upsell modal. Any surface (e.g. the sidebar, a class
// component) can trigger it via openUpgradeModal(featureKey). The store itself
// lives in ./upgradeModalStore so FeatureGate can open the modal too.
export { useUpgradeModal, openUpgradeModal };

// Mounted once at the app root.
export const UpgradeModalHost = () => {
    const open = useUpgradeModal((s) => s.open);
    const featureKey = useUpgradeModal((s) => s.featureKey);
    const hide = useUpgradeModal((s) => s.hide);
    return (
        <Modal open={open} onCancel={hide} footer={null} width={420} centered destroyOnClose>
            <div style={{ padding: '12px 8px 8px' }}>
                <UpsellContent featureKey={featureKey} onContact={hide} />
            </div>
        </Modal>
    );
};
